import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Menu20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path d='M18 4.75H2V3.25H18V4.75Z' fill='currentColor' />
    <path d='M18 10.75H2V9.25H18V10.75Z' fill='currentColor' />
    <path d='M2 16.75H18V15.25H2V16.75Z' fill='currentColor' />
  </Svg>
);

Menu20.displayName = 'Menu20';
export default Menu20;
